import './Projects.css';
import { useEffect } from 'react';

function Projects({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const projects = [
    {
      title: "Snake & Ladder Game",
      desc: "A fully functional digital version of the classic board game, featuring player vs player or player vs CPU modes, complete with sound effects and animations.",
      tools: ["Python", "Pygame", "Object-Oriented Programming"],
      role: "Lead Developer",
      course: "CPE-OOP"
    },
    {
      title: "Pacman Game on FPGA",
      desc: "A complete hardware implementation of the classic Pacman arcade game on an FPGA board, featuring custom game logic, state machines, and VGA display output.",
      tools: ["Verilog", "FPGA", "VGA Interface", "Digital Logic"],
      role: "Hardware Developer",
      course: "CPE-MIC"
    },
    {
      title: "3D Heat Conduction on Metal Plates",
      desc: "A simulation tool solving Partial Differential Equations (PDE) to visualize 3D heat distribution over time across various metal plate materials.",
      tools: ["MATLAB", "Numerical Methods", "PDEs"],
      role: "Simulation Engineer",
      course: "CPE-MATH"
    },
    {
      title: "MicroLab Inventory Management System",
      desc: "A comprehensive laboratory inventory system for tracking electronic components, microcontrollers, and tools, featuring checkout and restock capabilities.",
      tools: ["React", "Node.js", "Firebase", "CSS"],
      role: "Full-Stack Developer",
      course: "CPE-OOP"
    },
    {
      title: "Two-Digit Decimal Counter PCB Design",
      desc: "Custom printed circuit board layout and schematic for a hardware two-digit 7-segment display counter utilizing 555 timers and logic gates.",
      tools: ["KiCad", "Circuit Design", "Logic Gates"],
      role: "Hardware Designer",
      course: "CPE-SYS"
    },
    {
      title: "Voice-Controlled LED System",
      desc: "An embedded system project utilizing an ESP32 microcontroller and Fast Fourier Transform (FFT) to process voice commands and control lighting patterns.",
      tools: ["ESP32", "C++", "FFT", "Audio Processing"],
      role: "Embedded Systems Developer",
      course: "ECE-DSP"
    },
    {
      title: "Graduate Tracer Study of CPE Graduates",
      desc: "A research project and accompanying web dashboard analyzing the employment statistics and curriculum relevance for recent Computer Engineering graduates.",
      tools: ["Data Analysis", "Python", "Pandas", "Chart.js"],
      role: "Data Analyst & Researcher",
      course: "RESEARCH"
    },
    {
      title: "Secure Digital Lock System",
      desc: "An FPGA-based digital lock system designed using Verilog with Authentication by Verification (ABV) concepts for enhanced hardware security.",
      tools: ["Verilog", "Quartus Prime", "FPGA", "Digital Logic"],
      role: "Hardware Verification Engineer",
      course: "CPE-HDL"
    },
    {
      title: "Restaurant Web App",
      desc: "A responsive front-end web application for a restaurant featuring online menus, reservation forms, and interactive UI components.",
      tools: ["HTML", "CSS", "JavaScript", "React"],
      role: "Front-End Developer",
      course: "sOFTWARE DESIGN"
    },
    {
      title: "Smart Room Access & Status Indication",
      desc: "An RFID-based room access control system integrated with LCD status indicators and automated logging.",
      tools: ["Arduino", "RFID", "C++", "Sensors"],
      role: "Embedded Developer",
      course: "EMBEDDED SYSTEM"
    },
    {
      title: "Sumo Bot",
      desc: "An autonomous, combat-ready robot built to locate and push opponents out of a ring using ultrasonic and line-tracking sensors.",
      tools: ["Arduino", "Motor Drivers", "Sensors", "C++"],
      role: "Robotics Programmer",
      course: "EMBEDDED SYSTEM"
    },
    {
      title: "Ambient Light-Based Smart Lighting System",
      desc: "An automated lighting control system that adjusts room brightness based on natural ambient light levels using LDR sensors and PID control.",
      tools: ["ESP32", "Control Systems", "LDR Sensors", "C++"],
      role: "Control Systems Engineer",
      course: "FEEDBACK AND CONTROL SYSTEM"
    }
  ];

  return (
    <div className="proj-page">

      {/* ── Header ── */}
      <header className="proj-header">
        <div className="proj-header-inner">
          <button className="proj-back-btn" onClick={onNavigateHome}>
            <span className="proj-back-arrow">&#8592;</span> Back to Portfolio
          </button>
          <nav className="proj-breadcrumb">
            <span className="proj-bc-home" onClick={onNavigateHome}>Home</span>
            <span className="proj-bc-sep">/</span>
            <span className="proj-bc-current">Projects</span>
          </nav>
        </div>
      </header>

      {/* ── Hero Strip ── */}
      <div className="proj-hero-strip">
        <div className="proj-strip-inner">
          <p className="proj-strip-label">Technical Outputs</p>
          <h1 className="proj-strip-name">Projects</h1>
          <p className="proj-strip-role">A collection of my academic, embedded, and software development work.</p>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="proj-main">
        <div className="proj-grid">
          {projects.map((proj, idx) => (
            <div className="proj-card" key={idx}>
              <div className="proj-card-content">
                <span className="proj-course">{proj.course}</span>
                <h3 className="proj-title">{proj.title}</h3>
                <p className="proj-desc">{proj.desc}</p>

                <div className="proj-tools">
                  {proj.tools.map((tool, tIdx) => (
                    <span className="proj-tool-tag" key={tIdx}>{tool}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="proj-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="proj-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>

    </div>
  );
}

export default Projects;
